import React__default, { forwardRef } from 'react';
import NvModal from '../../NvModal/NvModal.esm.js';
import { useTags } from '../NvTagsContext/useTags.esm.js';
import NvTagsInput from '../NvTagsInput/NvTagsInput.esm.js';

var NvTagsBody = forwardRef(function (_a, ref) {
    var modalTitle = _a.modalTitle, _b = _a.modalButtonText, modalButtonText = _b === void 0 ? 'Finish' : _b, children = _a.children, size = _a.size, buttonAddText = _a.buttonAddText, showClearButton = _a.showClearButton, readonly = _a.readonly, modalBodyFullWidth = _a.modalBodyFullWidth;
    var handleFinish = useTags().handleFinish;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(NvTagsInput, { buttonAddText: buttonAddText, readonly: readonly, showClearButton: showClearButton, size: size }),
        React__default.createElement(NvModal, { bodyFullWidth: modalBodyFullWidth, classes: {
                modal: 'nv-tags-modal',
            }, headerText: modalTitle, onPrimaryButtonClicked: handleFinish, primaryButtonText: modalButtonText, ref: ref, showCloseButton: true }, children)));
});
NvTagsBody.displayName = 'NvTagsBody';

export { NvTagsBody as default };
//# sourceMappingURL=NvTagsBody.esm.js.map
